import { ThemeEvents } from '@theme/events';

// Follow only successful native product-form additions, not quantity edits/errors.
let navigating = false;
document.addEventListener(ThemeEvents.cartUpdate, event => {
  const data = event.detail?.data;
  if (navigating || data?.didError || data?.source !== 'product-form-component' || !(data.itemCount > 0)) return;
  const destination = document.querySelector('[data-tp-cart-destination]');
  if (!destination || destination.dataset.afterAdd !== 'cart') return;
  navigating = true;
  window.location.assign(destination.href);
});
